import template from 'text!./templates/endorsement-lob-flow.html';

export default [function () {
    return {
        template: template,
        'scope': {
            'wizard': '=',
            'flow': '=',
            'isStateVisible': '='
        },
        controller: ['$scope', 'endorsement.LobUtil', function ($scope, LobUtil) {
            $scope.isPA = function (productCode) {
                return LobUtil.isPA(productCode);
            };
            $scope.isHomeowners = function (productCode) {
                return LobUtil.isHomeowners(productCode);
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/endorsement/directives/EndorsementLobFlow.js
// module id = 2208
// module chunks = 0